// Mantém paridade 1:1 com backend `AuditAction` enum
// (backend/src/features/audit/entities/audit-log.entity.ts).
export const AUDIT_ACTIONS = [
  // Auth
  'auth.login',
  'auth.logout',
  'auth.login_failure',
  'auth.login_locked',
  'auth.refresh_reuse',
  'auth.csrf_failure',
  // Users
  'user.create',
  'user.update',
  'user.delete',
  // Folders
  'folder.create',
  'folder.update',
  'folder.delete',
  'folder.view',
  'folder.download',
  'folder.owner_change',
  // Files
  'file.upload',
  'file.migrated',
  'file.view',
  'file.download',
  'file.bulk_download',
  'file.update',
  'file.delete',
  'file.owner_change',
  // Shares
  'share.grant_user',
  'share.grant_group',
  'share.grant_org',
  'share.grant_link',
  'share.access',
  'share.download',
  'share.update',
  'share.revoke',
] as const;

export type AuditAction = (typeof AUDIT_ACTIONS)[number];

export const AUDIT_RESOURCE_TYPES = ['user', 'folder', 'file', 'share', 'auth'] as const;
export type AuditResourceType = (typeof AUDIT_RESOURCE_TYPES)[number];

export interface AuditLog {
  id: string;
  userId?: string;
  user?: {
    id: string;
    name: string;
    email: string;
  };
  action: AuditAction;
  resourceType?: AuditResourceType | string;
  resourceId?: string;
  resourceName?: string;
  metadata?: Record<string, unknown>;
  ipAddress?: string;
  userAgent?: string;
  createdAt: string;
}

export interface AuditQueryParams {
  userId?: string;
  action?: AuditAction;
  resourceType?: AuditResourceType;
  resourceId?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
}
